export type TranslationConfig = {
  translations: {
    [key in SupportedLanguage]: CfTranslations;
  };
};

export enum SupportedLanguage {
  EN = 'en',
  DE = 'de',
}

export interface CfTranslations {
  [key: string]: CfTranslation;
}

export interface CfTranslation {
  [key: string]: CfTranslation | string;
}
